
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"260","height":"50","viewBox":"0 0 260 50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 0v5h5v5h5v5h5v5h5V0h15v50H35V35h-5v-5h-5v-5h-5v-5h-5v30H0V0h15zm55 50H55V0h50v10H70v10h30v10H70v20zm40-40V0h45v10h-15v40h-15V10h-15zm110 20v-5h5v-5h5v-5h5v-5h-25V0h50v10h-5v5h-5v5h-5v5h-5v5h-5v5h-5v5h30v10h-50V35h5v-5h5zm-45-20h-15V0h45v10h-15v30h15v10h-45V40h15V10z","fill":"#0C7C95","fill-rule":"evenodd"}})])
          )
        }
      }
    